export const organizationBrandingFileTypes = [
    'senderMenuLogo',
    'senderMenuIcon',
    'emailHeaderLogo',
    'recipientHeaderLogo',
    'recipientHeaderIcon',
];
export const TASK_STATUS = [
    'PREPARING_TO_SEND',
    'READY_TO_SEND',
    'NOT_STARTED',
    'IN_PROGRESS',
    'NEEDS_REVIEW',
    'SENT_BACK',
    'ACCEPTED',
    'CANCELLED',
    'DECLINED',
];
//# sourceMappingURL=models.js.map